import { Row, Col } from 'react-bootstrap';

type IpaAdministrationWizardAhcPoiProps = {
    register: any;
    getValues: any;
    errors: Record<string, any>;
};

const IpaAdministrationWizardAhcPoi = (props: IpaAdministrationWizardAhcPoiProps) => (
    <Row className='accordion-content'>
        <Col md={6}>
            <div className={`e-float-input e-input-group e-input-group-margin`}>
                <input
                    type='text'
                    {...props?.register('manager', {
                        maxLength: {
                            value: 60,
                            message: 'Manager must be maximum 60 characters length',
                        },
                    })}
                    defaultValue={props?.getValues()?.manager}
                />
                <span className='e-float-line'></span>
                <label className='e-float-text'>Manager</label>
            </div>
            {props?.errors?.manager && <p className='error-form'>{props.errors.manager.message}</p>}
        </Col>

        <Col md={6}>
            <div className={`e-float-input e-input-group`}>
                <input
                    type='text'
                    {...props?.register('specialist', {
                        maxLength: {
                            value: 60,
                            message: 'Specialist must be maximum 60 characters length',
                        },
                    })}
                    defaultValue={props?.getValues()?.specialist}
                />
                <span className='e-float-line'></span>
                <label className='e-float-text'>Specialist</label>
            </div>
            {props?.errors?.specialist && <p className='error-form'>{props.errors.specialist.message}</p>}
        </Col>
    </Row>
);

export default IpaAdministrationWizardAhcPoi;
